<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Stocking Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: '',
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        consumable: '',
        title: 'Consumables Stocking Report'
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Consumables Stocking Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables Stocking Report",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount:0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData:[],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT_MEASURE",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT_PRICE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT_MEASURE",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT_PRICE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        }
      ],
      json_fields: {
        ITEM: "item.name",
        UNIT_MEASURE: "unit.name",
        QUANTITY: "qty",
        UNIT_PRICE : "unit_price",
        DATE: "date",
        RECORDED_BY: "user.name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("consumables", ["ConsumablesStock","Consumables"]),
    ...mapGetters("auth", ["branchid","Branches"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredData ? this.filteredData.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesStock ? this.ConsumablesStock.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumableStock: "consumables/fetchConsumablesStock",
      FetchConsumables: "consumables/fetchConsumables",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    SetData(){
        if(this.ConsumablesStock){
            this.filteredData = this.ConsumablesStock;
        }
    },
    filterReport() {
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      let consumable = this.data.consumable;
      this.filteredData = this.ConsumablesStock.filter((element) => {
        if (this.data.consumable != "" && this.data.datefrom == "" && this.data.dateto != "") {
          this.Consumables.filter((element) => {
            if (element.id == consumable) {
              let expcat = element.name;
              this.data.title =
                "Consumables Stocking Report For " + expcat + " Up To " + this.data.dateto;
            }
          });
          return element.item.id == consumable && element.date <= date2;
        } else if (
          this.data.consumable == "" &&
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
          this.data.title =
            "Consumables Stocking From " + this.data.datefrom + " To " + this.data.dateto;
            return element.date >= date1 && element.date <= date2;
        } else if (
          this.data.consumable != "" &&
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
            this.Consumables.filter((element) => {
            if (element.id == consumable) {
              let expcatx = element.name;
              this.data.title =
                "Consumables Stocking for " +
                expcatx +
                " From " +
                this.data.datefrom +
                " To " +
                this.data.dateto;
            }
          });
          return (
            element.item.id == consumable &&
            element.date >= date1 &&
            element.date <= date2
          );
        }else{
          this.filteredData = this.ConsumablesStock;
        }
      });
    },
  },
  updated() {
    let total_price = 0;
      if(this.filteredData){
        this.filteredData.forEach((item)=>{
          total_price = total_price+parseInt(item.unit_price);
        });
        this.total_amount = total_price;
      }
  },
  watch: {
    ConsumablesStock(newValue){
      if(newValue){
        this.SetData();
      }
    }
  },
  created() {
    this.SetData();
    this.FetchConsumableStock();
    this.FetchConsumables();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredData"
                  :fields="json_fields"
                  :worksheet="'PURCHASE PAYMENTS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Purchasepayments_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="filterReport()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="filterReport()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>ITEM</label>
                
                <model-list-select
                  :list="Consumables ? Consumables : []"
                  v-model="data.consumable"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Consumable"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredData?filteredData:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(unit_price)="data">
                  {{ thousandSeperator(data.item.unit_price) }}
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-4">
                    <h5>Total Price: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!filteredData"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
